export default __webpack_public_path__ + "static/media/palaute.b90437fe.svg";